/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum GreylistState {
  NotVerified = 'not_verified',
  Verified = 'verified',
  Critical = 'critical',
  Blocked = 'blocked'
}
